import React from "react";
import { FaPollH } from "react-icons/fa";
import Link from 'hooks/Link';
const FillKYCAction = () => {
  return (
    <>
      <div className="join-banner mt-2" style={{}}>
        <p>
           Please Fill Out KYC Form
        </p>
        <button
          className="lp-btn fill square text-center"
        >
          <FaPollH />
        </button>
      </div>
    </>
  );
};

export default FillKYCAction;
